<template>

  <div class="product">
    <!--搜索-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="用户ID">
          <el-input size="small" v-model="searchForm.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <el-input size="small" v-model="searchForm.mobile" placeholder="请输入用户电话"></el-input>
        </el-form-item>
         <el-form-item label="审核状态">
            <el-select size="small" v-model="searchForm.status" clearable placeholder="请选择" >
              <el-option label="全部" value="-1"></el-option>
              <el-option label="待审核" :value="0"></el-option>
              <el-option label="已通过" :value="1"></el-option>
              <el-option label="未通过" :value="2"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table  size="small" :data="tableData" border style="width: 100%" v-loading="loading">

          <el-table-column prop="user" label="用户" >
            <template  slot-scope="scope">
               <div >
                  <p>昵称：{{scope.row.user.nickName}}</p>
                  <p>电话：{{scope.row.user.mobile}}</p>
                  <p class="gray9">(用户ID：{{scope.row.user.user_id}})</p>
               </div>
            </template>
          </el-table-column>
          <el-table-column prop="content" label="分享内容">
            <template slot-scope="scope">
              <span style="white-space: nowrap">
                  {{scope.row.content}}
                </span>
              <el-popover
                placement="top-start"
                title="分享内容"
                width="400"
                trigger="click"
                :content="scope.row.content">
                <el-button slot="reference"  type="text">查看全部</el-button>
              </el-popover>
            </template>
            
          </el-table-column>

          <el-table-column prop="images" label="分享图片">
            <template slot-scope="scope">
              <div>
                <el-image 
                  v-for="url in scope.row.images" 
                  :key="url"
                  style="width: 80px; height: 80px"
                  :src="url" 
                  :preview-src-list="scope.row.images">
                </el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <div class="d-s-c">
               <el-tag v-if="scope.row.status == 0" >待审核</el-tag>
              <el-tag v-if="scope.row.status == 1" type="success" class="green">已通过</el-tag>
              <el-tag v-if="scope.row.status == 2" type="info" class="green">已拒绝</el-tag>
              
            </div>
            <div  v-if="scope.row.status == 2">{{scope.row.reject_reason}}</div>
          </template>
        </el-table-column>
          <!-- <el-table-column prop="video_url" label="分享视频">
            <template slot-scope="scope">
              <video v-if="scope.row.video_url" :src="scope.row.video_url" width="100px" height="120px" controls="controls" />
            </template>
            
          </el-table-column> -->

          <el-table-column prop="create_time" label="创建时间" width="135"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
               <el-button @click="commentClick(scope.row)" type="text" size="small">评论记录</el-button>
              <el-button  v-if="scope.row.status == 0" @click="editClick(scope.row)" type="text" size="small">
                  审核
                </el-button>
                <template v-if="scope.row.status == 1">
                  <el-button  v-if="scope.row.status == 1" @click="topClick(scope.row)" type="text" size="small">
                    {{ scope.row.is_top==1?'取消置顶':'置顶' }}
                  </el-button>
                </template>
             
              <el-button @click="delClick(scope.row)" type="text" size="small" >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="Oneform.model" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>

  </div>
</template>

<script>
  import DiaryApi from '@/api/diary.js';
  import Edit from './dialog/Edit.vue';
  export default {
    components: {
      /*编辑组件*/
      Edit
    },
    data() {
      return {
        //加载
        loading: true,// true 为加载中   false 加载结束

        // 选项卡控制
        activeName: 'all',

        //搜索控制
        searchForm: {
          user_id: ''  ,//用户id
          mobile:'',
        },
        //表格数据
        tableData: [],/*列表数据*/
        totalDataNumber: 0,/*总条数*/
        pageSize: 20,/*一页多少条*/
        curPage: 1,/*当前是第几页*/


        /*是否打开添加弹窗*/
        open_add: false,
        open_edit: false,
        /*选择的当前行对象数据*/
        Oneform:{
          type:'add',
          model:{}
        },
        /*省市区*/
        areaList: [],

      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
        commentClick(row){
          let diary_id = row.id;
          this.$router.push({
            path: '/diary/diary/comment',
            query: {
              diary_id: diary_id,
            }
          })
        },
       // 选项卡 start
       handleClick(tab, event) {
         /*切换选项卡 */
         let self = this;
         self.curPage = 1; //变为第一页
         self.loading = true;//加载中
         self.activeName = tab.name;
         self.getData(); //获取数据
       },
       // 选项卡 end


       /*搜索查询*/
       onSubmit() {
         let self = this;
         self.curPage = 1; //变为第一页
         self.loading = true;//加载中
         self.getData();//获取数据
       },

      //列表数据 start

      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val; //选择的页数
        self.loading = true; //加载中
        self.getData();//获取数据
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;  //调到第一页
        this.pageSize = val; //每页多少条
        this.getData(); //获取数据
      },

      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params = self.searchForm; //搜索
        Params.activeStatus = self.activeName; //选项卡
        Params.page = self.curPage; //当前页数
        Params.list_rows = self.pageSize;//每页多少条

        //请求接口
        DiaryApi.getList(Params, true).then(res => {

          self.loading = false;//加载结束
          self.tableData = res.data.list.data; //把数据给列表
          self.totalDataNumber = res.data.list.total;//一共多少条

        }).catch(error => {
          self.loading = false; //加载结束
        });
      },

      //列表数据 end

      //操作 start

      /*初始化城市id*/
      initCity() {
        this.searchForm.city_id = ''
      },
      /*初始化区id*/
      initRegion() {
        this.searchForm.region_id = ''
      },

      /*删除*/
      delClick: function(row) {
        let self = this;
        self.loading = true;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {

          //请求接口
          DiaryApi.del({
            id: row.id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          }).catch(() =>{
            self.loading = false;
          });
        }).catch(() =>{
          self.loading = false;
        });
      },

     
      //编辑
      editClick($row){
        this.Oneform.model = $row;
        this.Oneform.type = 'edit';
        this.agent = $row;
        this.open_edit = true;
      },
      topClick(item){
        let self = this;
        let msg = '确认将该内容置顶吗？';
        if(item.is_top==1){
          msg = '确认取消内容置顶吗？';
        }
        self.$confirm(msg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          DiaryApi.topset(
            {
              id: item.id,
              is_top:item.is_top
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.loading = false;
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {});
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getData();
        }
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/diary/diary/index.vue